import { PrimeReactProvider } from "primereact/api";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
/* The themed stylesheet itself is injected by ThemeProvider, which swaps
   between the light and dark builds. */

import CornerLogo from "./components/CornerLogo";
import "./i18n";
import "./index.css";
import { router } from "./router";
import { ThemeProvider } from "./theme/ThemeProvider";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <PrimeReactProvider value={{ ripple: true }}>
        <RouterProvider router={router} />
        <CornerLogo />
      </PrimeReactProvider>
    </ThemeProvider>
  </React.StrictMode>
);
